import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";
//IMAGES

export const HeaderContainer = styled.header`
  font-family: 'Outfit', sans-serif;
  padding: 20px 0px;
  background-color: #fff;
  z-index: 9999;
  position: relative;

  /* Student Login button: same orange as "Join the Classroom Pilot" (C.cta in WebsiteTheme).
     The button arrow is drawn red, so recolour it. */
  .customs_btn {
    background: linear-gradient(90deg, #e2531a 0%, #cc430c 100%);
    box-shadow: 0 12px 24px -12px rgba(214, 72, 14, 0.75);

    &:hover {
      background: linear-gradient(90deg, #cf460f 0%, #b83a09 100%);
    }

    svg [fill="#EE2D2F" i] {
      fill: #e2531a;
    }
  }

  /* Social icons: same blue as the footer icons (navy on hover, like the footer) */
  .social_handles svg path[fill="#EE2D2F" i] {
    fill: #1f63e0;
    transition: fill 0.2s ease;
  }

  .social_handles a:hover svg path[fill="#EE2D2F" i] {
    fill: #142a6e;
  }
  .header_logo {
    display: flex;
    align-items: center;
    svg,
    img {
      height: 50px;
      width: auto;
    }
  }

  .header_navs_menu {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-start;
      gap: 34px;
      padding: 0;
      margin: 0;
      @media screen and (max-width: 1320px) {
        gap: 20px;
      }

      li {
        a {
          text-decoration: none;
          font-weight: 300;
          color: #333;
          transition: color 0.3s ease;

          &:hover {
            color: #1f63e0; /* same hover as the footer links */
          }
        }
        span{
          text-decoration: none;
          font-weight: 300;
          color: #333;
          transition: color 0.3s ease;

          &:hover {
            color: #1f63e0;
          }
        }
      }
    }
  }
  .active {
    color: #1f63e0 !important; /* current page: same blue as the hover */
  }
  .menu_other_buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* Tighter than before so "Teacher Login" and "Student Login" fit on one line without
       pushing the social icons into the menu (checked from 1200px up) */
    gap: 12px;
    .portal_login_link a,
    .portal_login_link span,
    .logins_btn button {
      white-space: nowrap;
    }
    .social_handles  {
      ul{
        padding: 0 !important;
        display: flex;
        align-items: center;
        list-style: none;
        li{
          padding: 0 8px;
          a{
            line-height: 1;
            display: block;
            &:hover{
              svg path:first-child{
                fill: ${COLORS.PrimaryBlue};
              }
            }
          }
          span{
            line-height: 1;
            display: block;
            &:hover{
              svg path:first-child{
                fill: ${COLORS.PrimaryBlue};
              }
            }
          }
        }
      }
    }
    .portal_login_link {
      padding: 0 4px;
      a {
        color: #000;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          font-family: 'Outfit', sans-serif;
          text-decoration: unset;
          line-height:1.1;
            @media screen and (max-width: 1320px) {
              font-size: 15px;
            }
        &:hover {
          text-decoration: unset;
          color: #1f63e0;
        }
      }
      span{
          color: #000;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          font-family: 'Outfit', sans-serif;
          text-decoration: unset;
          line-height:1.1;
            @media screen and (max-width: 1320px) {
              font-size: 15px;
            }
        &:hover {
          text-decoration: unset;
          color: #1f63e0;
        }
      }
  }


  /* Responsive Breakpoints */
  @media (max-width: 768px) {
    .header_navs_menu ul {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }

    .menu_other_buttons {
      flex-direction: column;
      gap: 10px;
    }
  }
`;

